__turbopack_context__.v({
  "hamburger": "mobile-module__DkJ7-a__hamburger",
  "menuItem": "mobile-module__DkJ7-a__menuItem",
  "mobileNavDropdown": "mobile-module__DkJ7-a__mobileNavDropdown",
  "navbar": "mobile-module__DkJ7-a__navbar",
});
